<template>
  <div class="survey-status-header form-group" v-if="!this.$parent.isSurveyEmpty && !this.$parent.displaySurveyWidget">
    <span class="section-label">Current Survey: {{ this.$parent.survey.name }}</span>
    <span class="section-label pl-3">Survey Status: </span>
    <span v-if="this.$parent.survey.active == 'Y'" class="text-success"> Active </span>
    <span v-else class="text-danger"> Not Active </span>
    <span class="section-label pl-3">Build Survey Required: </span>
    <span v-if="this.$parent.survey.buildRequired == 'Y'" class="text-danger"> Yes </span>
    <span v-else class="text-success">No</span>
    <span class="section-label pl-3">URL Status for </span>
    <span v-if="this.$parent.doesSurveyUrlWork"> {{ $parent.liveSurveyUrl }} </span>
    <span v-else class="text-danger">{{ $parent.liveSurveyUrl }} </span>
    <span>: </span>
    <span v-if="this.$parent.doesSurveyUrlWork" class="text-success"> Working </span>
    <span v-else class="text-danger">Not Working</span>
  </div>
</template>
<script>
export default {
  name: "SurveyStatus",
  components: {},
  data() {
    return {};
  },
  props: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {}
};
</script>
